import { ColumnType } from "antd/es/table";

export const getColumnSortOrder = (
  columnKey: string,
  sortField?: string,
  sortType?: string,
): "ascend" | "descend" | undefined => {
  if (sortField !== columnKey) {
    return undefined;
  }

  if (sortType === "ASC") {
    return "ascend";
  }

  if (sortType === "DESC") {
    return "descend";
  }

  return undefined;
};

const getColumnKey = <T>(column: ColumnType<T>): string | undefined => {
  if (column.key != null) {
    return String(column.key);
  }

  const { dataIndex } = column;

  if (Array.isArray(dataIndex)) {
    const first = dataIndex[0];
    return first != null ? String(first) : undefined;
  }

  if (dataIndex != null) {
    return String(dataIndex);
  }

  return undefined;
};

export const applySortToColumns = <T>(
  columns: ColumnType<T>[],
  sortField?: string,
  sortType?: string,
  sortableColumns?: string[],
): ColumnType<T>[] =>
  columns.map((column) => {
    if (column.children?.length) {
      return {
        ...column,
        children: applySortToColumns(
          column.children,
          sortField,
          sortType,
          sortableColumns,
        ),
      };
    }

    const columnKey = getColumnKey(column);
    const isSortable = !!columnKey && !!sortableColumns?.includes(columnKey);

    if (!isSortable) {
      return column;
    }

    return {
      ...column,
      sorter: true,
      sortOrder: getColumnSortOrder(columnKey, sortField, sortType),
    };
  });
